/* eslint-disable camelcase */
import { createReducer } from '@reduxjs/toolkit';
import { ProfileActions } from './actions';
import Constants from './constants';

const initialState = {
  profileDetails: {},
  password: {},
  profileDetailsUpdateStatus: null,
  passwordUpdateStatus: null,
  isLoadingPassword: false,
  isLoadingProfileUpdate: false,
  invitation: {
    isInvited: false,
    inviteId: null,
    invitedBy: '',
    invitedByOrgName: '',
  },
};

const ACTION_HANDLER = {
  [ProfileActions.rejectInviteSucceeded]: (state) => {
    state.invitation = {
      isInvited: false,
      invitedBy: null,
      invitedByOrgName: '',
      inviteId: '',
    };
  },
  [ProfileActions.profileDetailsFetchSucceeded]: (state, action) => {
    state.profileDetails = action.payload;
  },
  [ProfileActions.profileDetailsFetch]: (state) => {
    state.passwordUpdateStatus = null;
  },
  [ProfileActions.changeProfileDetails]: (state) => {
    state.isLoadingProfileUpdate = true;
  },
  [ProfileActions.changeProfileDetailsSucceeded]: (state, action) => {
    state.profileDetails = action.payload;
    state.profileDetailsUpdateStatus = true;
    state.isLoadingProfileUpdate = false;
  },
  [ProfileActions.changeProfileDetailsFailed]: (state) => {
    state.profileDetailsUpdateStatus = false;
    state.isLoadingProfileUpdate = false;
  },
  [ProfileActions.changePassword]: (state) => {
    state.isLoadingPassword = true;
    state.passwordUpdateStatus = null;
  },
  [ProfileActions.changePasswordSucceeded]: (state, action) => {
    state.password = action.payload;
    state.passwordUpdateStatus = true;
    state.isLoadingPassword = false;
  },
  [ProfileActions.changePasswordFailed]: (state) => {
    state.passwordUpdateStatus = false;
    state.isLoadingPassword = false;
  },
  [ProfileActions.checkIsInvitedSucceeded]: (state, action) => {
    if (!action.payload.length) {
      return;
    }
    const [invite] = action.payload;

    state.invitation = {
      isInvited: true,
      inviteId: invite.id,
      invitedBy: invite.organization_admin,
      invitedByOrgName: invite.organization_name,
    };
  },
  [ProfileActions.moveAccountSucceeded]: (state, action) => {
    state.invited = false;
  },
};

export const profileReducer = createReducer(initialState, ACTION_HANDLER);

export default {
  name: Constants.MODULE_NAME,
  reducer: profileReducer,
};
